(function () {
  var FLASH_MS = 1600;
  var TOAST_MS = 5000;
  var TOAST_RESUME_MS = 2500;
  var toast = null;
  var toastTimer = null;

  function ensureToast() {
    if (toast) return toast;
    toast = document.createElement('aside');
    toast.className = 'colfax-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<img class="colfax-cart-toast__image" alt="" width="54" height="54" hidden>' +
      '<span class="colfax-cart-toast__body">' +
      '<span class="colfax-cart-toast__kicker">✓ Added to cart</span>' +
      '<span class="colfax-cart-toast__item"></span>' +
      '<span class="colfax-cart-toast__count"></span>' +
      '</span>' +
      '<a class="colfax-cart-toast__view" href="/cart">View cart</a>' +
      '<button class="colfax-cart-toast__close" type="button" aria-label="Dismiss">&times;</button>';
    toast.querySelector('.colfax-cart-toast__view').href =
      window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    toast.querySelector('.colfax-cart-toast__close').addEventListener('click', hideToast);
    toast.addEventListener('mouseenter', holdToast);
    toast.addEventListener('focusin', holdToast);
    toast.addEventListener('mouseleave', releaseToast);
    toast.addEventListener('focusout', releaseToast);
    document.body.appendChild(toast);
    return toast;
  }

  function holdToast() {
    clearTimeout(toastTimer);
  }

  function releaseToast() {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_RESUME_MS);
  }

  function hideToast() {
    clearTimeout(toastTimer);
    if (toast) toast.classList.remove('is-open');
  }

  function itemSubtitle(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    var properties = item.properties || {};
    var parts = [];
    Object.keys(properties).forEach(function (key) {
      if (key.charAt(0) === '_') return;
      if (typeof properties[key] === 'string' && properties[key]) parts.push(properties[key]);
    });
    return parts.join(' · ');
  }

  function showToast(item) {
    var element = ensureToast();
    var image = element.querySelector('.colfax-cart-toast__image');
    if (item.image) {
      image.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      image.hidden = false;
    } else {
      image.removeAttribute('src');
      image.hidden = true;
    }
    var title = item.product_title || 'Item added';
    var subtitle = itemSubtitle(item);
    element.querySelector('.colfax-cart-toast__item').textContent = subtitle ? title + ' — ' + subtitle : title;
    element.querySelector('.colfax-cart-toast__count').textContent = '';
    element.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  function updateToastCount(count) {
    if (!toast || !toast.classList.contains('is-open')) return;
    toast.querySelector('.colfax-cart-toast__count').textContent =
      count === 1 ? '1 item in cart' : count + ' items in cart';
  }

  function pulseCartBubble() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('is-pulsing');
    void bubble.offsetWidth;
    bubble.classList.add('is-pulsing');
  }

  function refreshCartIcon(count) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var icon = document.getElementById('cart-icon-bubble');
        if (icon && sections['cart-icon-bubble']) icon.innerHTML = sections['cart-icon-bubble'];
        pulseCartBubble();
      })
      .catch(function () {});
    updateToastCount(count);
  }

  function flash(button, text, isError) {
    if (!button) return;
    var label = button.querySelector('span') || button;
    if (!button.dataset.colfaxOriginalLabel) button.dataset.colfaxOriginalLabel = label.textContent;
    label.textContent = text;
    button.classList.add(isError ? 'colfax-add-flash--error' : 'colfax-add-flash--ok');
    button.disabled = true;
    setTimeout(function () {
      label.textContent = button.dataset.colfaxOriginalLabel;
      delete button.dataset.colfaxOriginalLabel;
      button.classList.remove('colfax-add-flash--ok', 'colfax-add-flash--error');
      button.disabled = false;
      button.dispatchEvent(new CustomEvent('colfax:cart:flash-done', { bubbles: true }));
    }, FLASH_MS);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      event.stopPropagation();

      var button = form.querySelector('button[type="submit"], [type="submit"]');
      if (button && button.disabled) return;
      var formData = new FormData(form);
      formData.delete('return_to');
      if (button) button.disabled = true;

      var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok || result.json.status) {
            flash(button, result.json.description || 'Unavailable', true);
            return;
          }
          var item = result.json.items ? result.json.items[0] : result.json;
          flash(button, '✓ Added', false);
          showToast(item);
          fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js')
            .then(function (response) { return response.json(); })
            .then(function (cart) { refreshCartIcon(cart.item_count); })
            .catch(function () {});
          document.dispatchEvent(
            new CustomEvent('colfax:cart:added', { detail: { form: form, item: item } })
          );
        })
        .catch(function () {
          flash(button, 'Try again', true);
        });
    },
    true
  );

  ensureToast();
})();
